import { FC } from 'react';
import {
  BooleanField,
  BooleanInput,
  Datagrid,
  List,
  NumberField,
  ReferenceInput,
  SearchInput,
  SelectInput,
  TextField,
} from 'react-admin';

import { UpdateChannelCurrentReleaseField } from './components/UpdateChannelCurrentReleaseField';
import { UpdateChannelHardwareField } from './components/UpdateChannelHardwareField';

const updateChannelFilters = [
  <SearchInput key="searchInput" source="q" alwaysOn />,
  <ReferenceInput key="referenceInput" source="hardware_id" reference="hardware" alwaysOn>
    <SelectInput source="name" />
  </ReferenceInput>,
  <BooleanInput source="active" />,
];

export const UpdateChannelList: FC = () => {
  return (
    <List filters={updateChannelFilters}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="name" />
        <UpdateChannelHardwareField label="resources.update_channels.fields.hardware_id" sortable={false} />
        <UpdateChannelCurrentReleaseField label="resources.update_channels.fields.current_releases" sortable={false} />
        <BooleanField source="active" />
        <NumberField source="units_count" />
      </Datagrid>
    </List>
  );
};
